import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { EventAvailable } from '@material-ui/icons';
import bookingMessages from 'modules/booking/messages';
import { ActionItem } from 'common/components';
import { restrictModifyEventByTime } from 'utils/booking.utils';
import ActionItemWarningIconByTime from 'common/components/ActionsMenu/ActionItemWarningIconByTime';
import BookingActionItemContainer from 'components/Booking/BookingActionItemContainer';

interface IBookingActionItemRestore {
  onClick: () => void;
  secondsBeforeEvent: number;
}

const BookingActionItemRestore: FC<IBookingActionItemRestore> = ({
  onClick,
  secondsBeforeEvent,
}) => {
  const intl = useIntl();
  let disableReason: JSX.Element | null = null;

  if (restrictModifyEventByTime(secondsBeforeEvent)) {
    disableReason = <ActionItemWarningIconByTime tooltipMsgType="restrictRestore" />;
  }

  const disabled = !!disableReason;

  return (
    <ActionItem
      key="restoreEventAction"
      disabled={disabled}
      onClick={!disabled ? onClick : undefined}
      icon={<EventAvailable />}
    >
      <BookingActionItemContainer message={intl.formatMessage(bookingMessages.restoreEventBtn)}>
        {disableReason}
      </BookingActionItemContainer>
    </ActionItem>
  );
};

export default BookingActionItemRestore;
